// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5OVV4 {\n  background-color: var(--color-white);\n  -webkit-box-shadow: var(--schoolinks-shadow);\n          box-shadow: var(--schoolinks-shadow);\n  z-index: 4;\n}\n\n.vYAP8 {\n  width: 33.33333%;\n}\n\n@media screen and (max-width: 1020px) {\n  .Eh8n7 {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    row-gap: 8px;\n  }\n\n  .vYAP8 {\n    width: 100%;\n  }\n\n  ._8D7I0 {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "_5OVV4",
	"third": "vYAP8",
	"headerWrapper": "Eh8n7",
	"buttons": "_8D7I0"
};
export default ___CSS_LOADER_EXPORT___;
